import { Switch, Route, withRouter } from 'react-router-dom';
import XmTracking from '@nkr/views/xm-tracking';

const AdminXmTrackingRoutes = (params) => {
    let url = params.url;

    return (
        <Switch>
            <Route exact path={`${url}/pending-shipping`} render={({ match: { params: subParams } }) => <XmTracking {...params} centerId={0} tab='pending-shipping' />} />
            <Route exact path={`${url}/shipped-pending-d-center`} render={({ match: { params: subParams } }) => <XmTracking {...params} centerId={0} tab='shipped-pending-d-center' />} />
            <Route exact path={`${url}/shipped-pending-r-center`} render={({ match: { params: subParams } }) => <XmTracking {...params} centerId={0} tab='shipped-pending-r-center' />} />
            <Route exact path={`${url}/completed`} render={({ match: { params: subParams } }) => <XmTracking {...params} centerId={0} tab='completed' />} />
            <Route exact path={`${url}/cancelled`} render={({ match: { params: subParams } }) => <XmTracking {...params} centerId={0} tab='cancelled' />} />
            <Route exact path={`${url}`} render={({ match: { params: subParams } }) => <XmTracking {...params} centerId={0} tab='pending-shipping' />} />
        </Switch>
    );
}

export default withRouter(AdminXmTrackingRoutes);